import { defineMessages } from 'react-intl';

export const rateFilterMenuMessages = defineMessages({
  filterByLabel: {
    defaultMessage: 'Filter by:',
    id: 'kQn/V7',
    description: 'Heading of the dropdown that filters the list of freight rate carriers',
  },
  filterAriaLabel: {
    defaultMessage: 'Filter rates',
    id: 'w0XLtX',
    description: 'Aria label for the icon button that opens the freight rate filter dropdown',
  },
  typeFilterLabel: {
    defaultMessage: 'Type',
    id: '125vLz',
    description: 'Label for the service type filter section in the freight rate filter dropdown',
  },
  typeDirect: {
    defaultMessage: 'Direct',
    id: 'o6BFEm',
    description: 'Freight rate filter option showing only offers with direct service (no terminal transfer)',
  },
  typeIndirect: {
    defaultMessage: 'Indirect',
    id: '22SJNK',
    description: 'Freight rate filter option showing only offers with indirect service (via terminal transfer)',
  },
  clearFilters: {
    defaultMessage: 'Clear',
    id: 'XfPqcv',
    description: 'Button that clears the selected freight rate filters',
  },
  applyFilters: {
    defaultMessage: 'Apply',
    id: '07bIuS',
    description: 'Button that applies the selected freight rate filters',
  },
});
